import { render, staticRenderFns } from "./RefundPaymentDDItem.vue?vue&type=template&id=44cd97f6&scoped=true"
import script from "./RefundPaymentDDItem.vue?vue&type=script&lang=js"
export * from "./RefundPaymentDDItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd97f6",
  null
  
)

export default component.exports